import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { YearOfSuitDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-year-of-suit-container',
  templateUrl: './year-of-suit-container.component.html',
  styleUrls: ['./year-of-suit-container.component.scss'],
})
export class YearOfSuitContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  yearofsuits$: Observable<YearOfSuitDto[]>;
  loading: boolean;
  isLoadingYearOfSuit$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingYearOfSuit$ = this.gatwayFacade.isLoadingGateway(
      'YearOfSuit'
    );
    this.yearofsuits$ = this.gatwayFacade.loadGateway('YearOfSuit');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteYearOfSuit(deletedValue: any) {
    this.gatwayFacade.remove('YearOfSuit', deletedValue);
  }

  // this method control both the create and update

  onSubmitYearOfSuit(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.YearOfSuits;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllYearOfSuit = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllYearOfSuit.push(pullData[i]);
      }
    }

    // check if the addAllYearOfSuit array is not empty, then dispatch the data to the store
    if (addAllYearOfSuit.length > 0) {
      this.gatwayFacade.add('YearOfSuit', addAllYearOfSuit);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('YearOfSuit', allUpdates, ['id']);
    }
  }
}
